export default function ({ route, store, redirect, app }) {
  const slug = route.params.slug
  const user = store.state.auth?.user
  if (slug === 'club-bet-777' && user && !user.is_club_bet_member) {
    return redirect(app.localePath({ path: '/promociones/club-bet-777' }))
  }
}